<div class="offline-container">
    <div>
        <h1>No Internet</h1>
        <p>Please check your internet connection and try again</p>
        <button (click)="onOffline()">Try Again</button>
    </div>
</div>